module.exports = __webpack_public_path__ + "/img/sage-icon.4485d2b24c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sage-icon.svg
// module id = 1397
// module chunks = 0